import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-statistiche-riepilogo',
	templateUrl: './statistiche-riepilogo.component.html',
	styleUrls: ['./statistiche-riepilogo.component.css']
})
export class StatisticheRiepilogoComponent implements OnInit {

	emissioniSync: Subscription;
	emissioni : any[];

	emissioneSelected : string = 'all';

	headerFields = [
		{
			label: "Emissione",
			code: "emissione",
			class: "tab-cell-6"
		},
		{
			label: "Stato",
			code: "stato",
			class: "tab-cell-6"
		},
		{
			label: "Num. Pratiche",
			code: "num_pratiche",
			class: "tab-cell-6"
		},
		{
			label: "Non SCAD",
			code: "non_scad",
			class: "tab-cell-6"
		},
		{
			label: "Dovuto",
			code: "dovuto",
			class: "tab-cell-6"
		},
		{
			label: "Pre Interessi",
			code: "pre_interessi",
			class: "tab-cell-6"
		},
		{
			label: "Pre Sanzioni",
			code: "pre_sanzioni",
			class: "tab-cell-6"
		},
		{
			label: "Pre Spese e Dir Not",
			code: "pre_spese_dir_not",
			class: "tab-cell-6"
		},
		{
			label: "Interessi Coattiva",
			code: "interessi_coattiva",
			class: "tab-cell-6"
		},
		{
			label: "Sanzioni Coattiva",
			code: "sanzioni_coattiva",
			class: "tab-cell-6"
		},
		{
			label: "Oneri di Riscossione",
			code: "oneri_riscossione",
			class: "tab-cell-6"
		},
		{
			label: "Spese e Dir di Notifica",
			code: "spese_diritti_notifica",
			class: "tab-cell-6"
		},
		{
			label: "CARICO TOTALE",
			code: "carico_totale",
			class: "tab-cell-6"
		},
		{
			label: "PAGATO",
			code: "pagato",
			class: "tab-cell-6"
		},
		{
			label: "RESIDUO",
			code: "residuo",
			class: "tab-cell-6"
		},
	];

	rowFields : any[] = [
		{
			"emissione" : "",
			"stato" : "",
			"num_pratiche" : "",
			"non_scad" : "",
			"dovuto" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"pre_spese_dir_not" : "",
			"interessi_coattiva" : "",
			"sanzioni_coattiva" : "",
			"oneri_riscossione" : "",
			"spese_diritti_notifica" : "",
			"carico_totale" : "",
			"pagato" : "",
			"residuo" : ""
		},
		{
			"emissione" : "",
			"stato" : "",
			"num_pratiche" : "",
			"non_scad" : "",
			"dovuto" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"pre_spese_dir_not" : "",
			"interessi_coattiva" : "",
			"sanzioni_coattiva" : "",
			"oneri_riscossione" : "",
			"spese_diritti_notifica" : "",
			"carico_totale" : "",
			"pagato" : "",
			"residuo" : ""
		},
		{
			"emissione" : "",
			"stato" : "",
			"num_pratiche" : "",
			"non_scad" : "",
			"dovuto" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"pre_spese_dir_not" : "",
			"interessi_coattiva" : "",
			"sanzioni_coattiva" : "",
			"oneri_riscossione" : "",
			"spese_diritti_notifica" : "",
			"carico_totale" : "",
			"pagato" : "",
			"residuo" : ""
		}
	]

	constructor(
		private dataService : DataService
		) { }

	ngOnInit() {
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioneSelected = 'all';
				if (emissioni) {
					this.emissioni = emissioni;
				}
				else {
					this.emissioni = [];
				}
			});
	}

}
